import { render, staticRenderFns } from "./awaken_wxwork.vue?vue&type=template&id=7e7e2f23&scoped=true"
import script from "./awaken_wxwork.vue?vue&type=script&lang=js"
export * from "./awaken_wxwork.vue?vue&type=script&lang=js"
import style0 from "./awaken_wxwork.vue?vue&type=style&index=0&id=7e7e2f23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7e2f23",
  null
  
)

export default component.exports